import { AuthLoginResponseService } from "../../services/auth/AuthenticationServices.type";
import { CLEAR_AUTH, SET_TOKEN } from "./actionTypes";

export const setToken = (tokens: AuthLoginResponseService) => ({
  type: SET_TOKEN,
  payload: tokens,
});

export const clearAuth = () => ({
  type: CLEAR_AUTH,
});
